import ModuleLayout from "../../components/enterprise/ModuleLayout";
import MapPanel from "../../components/enterprise/MapPanel";
import { intelligenceTabs } from "../navigation";
import { useTranslation } from "react-i18next";
import EmptyState from "../../components/dashboard/EmptyState";
import { usePlatform } from "../../context/PlatformContext";

const IntelligenceMapPage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  return (
    <ModuleLayout title={t("platform.pages.intelligenceMap.title")} subtitle={t("platform.pages.intelligenceMap.subtitle")} breadcrumbs={[t("platform.nav.intelligence"), t("platform.tabs.storeMap")]} tabs={intelligenceTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? (
        <MapPanel dataMode={{ mode: "mock", source: t("platform.sources.storeIntelligence") }} />
      ) : (
        <EmptyState title={t("platform.mock.disabledTitle")} description={t("platform.mock.disabledMapDescription")} />
      )}
    </ModuleLayout>
  );
};

export default IntelligenceMapPage;
